module.exports = __webpack_public_path__ + "static/bgposter-06e7c95799dfc3d14459a4c10b9c8c93.jpg";